import { postAsync } from './_base';

const postRequestQuote = (
  firstName?: string,
  lastName?: string,
  email?: string,
  phoneNumber?: string,
  comments?: string,
  media?: string,
  producturl?: string,
  productname?: string,
  publisher?: string,
  requestQuoteApiUrl?: string
) => {
  return postAsync(requestQuoteApiUrl ?? '', undefined, {
    firstname: firstName,
    lastname: lastName,
    email: email,
    phone: phoneNumber,
    comment: comments,
    media: media,
    producturl: producturl,
    productname: productname,
    publisher: publisher,
  });
};
const postRequestQuoteForLoggedIn = (media?: string, producturl?: string, productname?: string, publisher?: string, requestQuoteApiUrl?: string) => {
  return postAsync(requestQuoteApiUrl ?? '', undefined, {
    media: media,
    producturl: producturl,
    productname: productname,
    publisher: publisher,
  });
};
export { postRequestQuote, postRequestQuoteForLoggedIn };
